﻿"use strict"
let initTextDone = false;

export function initTexts() {
    if (initTextDone) return;
    initTextDone = true;
    let dict = {
        "de": {
            "Yes": "Ja",
            "No": "Nein",
            "dxPager-pageSizesAllText": "Alle"
        }
    };
    DevExpress.localization.loadMessages(dict);
    DevExpress.localization.locale("de");
}
